<template>
  <div class="menu">
    <nav class="site-nav navbar navbar-expand bg-white navbar-light">
      <div class="container-fluid">
        <div class="navbar-brand font-weight-bold">
          <img class="mt-2 ml-5" :src="this.logo" width="350px" />
        </div>
        <div class="navbar-nav ml-auto">
          <a href="#" id="popover-target-1">
            <div v-if="showMenu">.</div>
            <font-awesome-icon
              v-else
              icon="bars"
              @click="toggleMenu"
            ></font-awesome-icon>
          </a>
          <b-popover
            target="popover-target-1"
            :show.sync="showMenu"
            triggers="click"
            placement="top"
          >
            <div class="text-right show-menu">
              <a href="#"
                ><font-awesome-icon
                  icon="times-circle"
                  @click="toggleMenu"
                ></font-awesome-icon
              ></a>
            </div>
            <div
              v-if="$route.path == '/' && user.uid"
              class="nav-item nav-link"
            >
              Home
            </div>
            <div v-else>
              <router-link v-if="user.uid" class="nav-item nav-link" to="/"
                >Home</router-link
              >
            </div>
            <div v-if="user.uid" class="nav-item nav-link">Profile</div>
            <div v-if="user.uid" class="nav-item nav-link">Settings</div>
            <div v-if="user.uid" class="nav-item nav-link">Help</div>
            <div v-if="user.uid" class="nav-item nav-link">
              <a role="button" @click="logout">Logout</a>
            </div>
            <div v-else class="container-fluid">
              <div v-if="$route.path == '/'">Login</div>
              <div v-else>
                <router-link class="nav-item nav-link" to="/"
                  >Login</router-link
                >
              </div>
              <div v-if="$route.path == '/register'">Create Account</div>
              <div v-else>
                <router-link class="nav-item nav-link" to="/register"
                  >Create Account</router-link
                >
              </div>
            </div>
          </b-popover>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
import Firebase from "firebase";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
export default {
  name: "Navigation",
  computed: {
    user: {
      get() {
        return this.$store.state.user;
      },
      set(value) {
        this.$store.commit("setUser", value);
      },
    },
  },
  data: function() {
    return {
      showMenu: false,
      logo: "https://i.imgur.com/KiP5t6y.png",
    };
  },
  methods: {
    logout: function() {
      Firebase.auth().signOut();
      this.user = null;
      this.$router.push("login");
    },
    toggleMenu: function() {
      this.showMenu = !this.showMenu;
    },
  },
  components: {
    FontAwesomeIcon,
  },
};
</script>
